import React, { useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

import { Navigation } from 'components/shared'
import Hamburger from './Hamburger'
import Menu from './Menu'

export default function Header({ pageIsDonate }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <div
        id="header"
        className="bg-black py-3 fixed w-full top-0 left-0 z-50 border-b-2 border-white"
      >
        <div className="w-11/12 mx-auto container flex items-center justify-between">
          <div className="w-[80px] md:w-[120px]">
            <Link to="/">
              <span className="sr-only">Home page</span>
              <StaticImage src="../../../images/logos/logo.png" alt="" />
            </Link>
          </div>
          <Hamburger open={open} setOpen={setOpen} />
          <Navigation inHeader pageIsDonate={pageIsDonate} />
        </div>
      </div>
      <Menu open={open} pageIsDonate={pageIsDonate} />
    </>
  )
}
